/**
 * Shared participant name normalization for SQLite seeds, migrations, and `db:init-local`.
 * Keep in sync with `foldParticipanteBusquedaText` in the app bundle.
 */

/** @param {unknown} value */
function foldParticipanteBusquedaText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

/** @param {{ exec?: Function, run?: Function, prepare?: Function }} db */
function listParticipanteNombreRows(db) {
  if (typeof db.prepare === 'function' && typeof db.exec !== 'function') {
    try {
      return db.prepare('SELECT id, nombre, nombre_normalizado FROM participantes').all();
    } catch {
      return [];
    }
  }
  const result = db.exec('SELECT id, nombre, nombre_normalizado FROM participantes');
  const values = result?.[0]?.values ?? [];
  return values.map((row) => ({
    id: row[0],
    nombre: row[1],
    nombre_normalizado: row[2],
  }));
}

/** @param {{ exec?: Function, run?: Function, prepare?: Function }} db */
function updateParticipanteNombreNormalizado(db, id, normalized) {
  if (typeof db.prepare === 'function' && typeof db.exec !== 'function') {
    db.prepare('UPDATE participantes SET nombre_normalizado = ? WHERE id = ?').run(normalized, id);
    return;
  }
  db.run('UPDATE participantes SET nombre_normalizado = ? WHERE id = ?', [normalized, id]);
}

/**
 * Repairs stale or empty `nombre_normalizado` from `nombre`.
 * Works with sql.js (`db.run`) and Node `DatabaseSync` (`db.prepare`).
 * @param {{ exec?: Function, run?: Function, prepare?: Function }} db
 * @returns {number} rows updated
 */
export function backfillParticipantesNombreNormalizado(db) {
  let count = 0;
  for (const row of listParticipanteNombreRows(db)) {
    const id = Number(row.id);
    if (!Number.isFinite(id)) continue;
    const expected = foldParticipanteBusquedaText(row.nombre);
    if (String(row.nombre_normalizado ?? '') !== expected) {
      updateParticipanteNombreNormalizado(db, id, expected);
      count += 1;
    }
  }
  return count;
}
